import {useLayoutEffect, useState} from 'react';

export const TLDRAW_TOOLBAR_SELECTOR = '.tlui-layout__top__left';
export const DEFAULT_TLDRAW_TOOLBAR_CLEARANCE = 248;
const TOOL_GAP = 8;
const CLEARANCE_HYSTERESIS = 12;

/**
 * Left inset for AUTHORS/REACH so they stay clear of tldraw's top-left tools.
 * Recomputes when the canvas or the tldraw toolbar changes size (chat open/close).
 */
export function useTldrawToolbarClearance(containerRef, remountKey) {
    const [clearance, setClearance] = useState(DEFAULT_TLDRAW_TOOLBAR_CLEARANCE);

    useLayoutEffect(() => {
        const container = containerRef.current;
        if (!container) return undefined;

        const measure = () => {
            const toolbar = container.querySelector(TLDRAW_TOOLBAR_SELECTOR);
            if (!toolbar) {
                setClearance((prev) => (
                    prev === DEFAULT_TLDRAW_TOOLBAR_CLEARANCE ? prev : DEFAULT_TLDRAW_TOOLBAR_CLEARANCE
                ));
                return;
            }
            const next = Math.max(
                0,
                Math.round(toolbar.getBoundingClientRect().right - container.getBoundingClientRect().left + TOOL_GAP),
            );
            setClearance((prev) => (
                Math.abs(prev - next) < CLEARANCE_HYSTERESIS ? prev : next
            ));
        };

        measure();
        if (typeof ResizeObserver === 'undefined') return undefined;

        const observer = new ResizeObserver(measure);
        observer.observe(container);
        const toolbar = container.querySelector(TLDRAW_TOOLBAR_SELECTOR);
        if (toolbar) observer.observe(toolbar);

        return () => observer.disconnect();
    }, [containerRef, remountKey]);

    return clearance;
}
